var x = Object.defineProperty;
var H = (e, r, t) => r in e ? x(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var $ = (e, r, t) => H(e, typeof r != "symbol" ? r + "" : r, t);
function O(e) {
  return e != null && typeof e.hydrate == "function" && typeof e.toJSON == "function";
}
function k(e) {
  return Symbol(e);
}
function R(e, r) {
  for (const t of e) {
    const n = r(t);
    if (n !== void 0)
      return n;
  }
}
function ee() {
  const e = /* @__PURE__ */ new Map(), r = [];
  return {
    set(t, n) {
      if (e.has(t))
        throw new Error(`Instance "${t.description}" is already registererd`);
      e.set(t, n());
    },
    get(t) {
      return e.get(t);
    },
    use(t) {
      if (r.includes(t))
        throw new Error(
          `Scenario "${t.displayName || t.id}" is already registered`
        );
      r.push(t);
    },
    matchRoute(t) {
      return R(r, (n) => n.matchRoute(t));
    },
    matchError(t) {
      return R(r, (n) => n.matchError(t));
    },
    matchDeeplink(t) {
      return R(r, (n) => n.matchDeeplink(t));
    },
    matchWidget(t) {
      return R(r, (n) => n.matchWidget(t));
    },
    has(t) {
      return r.some((n) => n.has(t));
    },
    toJSON() {
      const t = {};
      return e.forEach((n, o) => {
        O(n) && (t[o.toString()] = n.toJSON());
      }), t;
    },
    hydrate(t) {
      e.forEach((n, o) => {
        if (!O(n))
          return;
        const i = t[o.toString()];
        i != null && n.hydrate(i);
      });
    }
  };
}
var w = 256, J = [], D = 256, N;
for (; w--; ) J[w] = (w + 256).toString(16).substring(1);
function y(e) {
  var r = 0, t = 11;
  if (!N || w + t > D * 2)
    for (N = "", w = 0; r < D; r++)
      N += J[Math.random() * 256 | 0];
  return N.substring(w, w++ + t);
}
const C = Symbol("widget");
function te() {
  const e = y(), r = {};
  return Object.defineProperties(r, {
    id: {
      value: e
    },
    kind: {
      value: C
    },
    name: {
      get() {
        return r.displayName ?? `widget(${e})`;
      }
    }
  });
}
function re(e) {
  const r = {}, t = {}, n = [], o = [], i = {
    addDeeplink(s) {
      n.push(s);
    },
    addError(s) {
      o.push(s);
    },
    addRoute(s) {
      const f = s.route;
      if (f.id in r)
        throw new Error(`Route "${f.name}" is already registered`);
      r[f.id] = s;
    },
    addWidget(s) {
      const f = s.widget;
      if (f.id in t)
        throw new Error(`Widget "${f.name}" is already registered`);
      t[f.id] = s;
    }
  }, a = y(), c = {
    get id() {
      return a;
    },
    get name() {
      return c.displayName ?? `scenario(${a})`;
    },
    init() {
      e(i);
    },
    matchError(s) {
      for (const f of o)
        if (f.is(s))
          return f;
    },
    matchRoute(s) {
      return r[s.id];
    },
    matchDeeplink(s) {
      for (const f of n) {
        const h = f.parse(s);
        if (h)
          return h;
      }
    },
    matchWidget(s) {
      return t[s.id];
    },
    has(s) {
      return s.kind === C ? s.id in t : s.id in r;
    }
  };
  return c.init(), c;
}
const L = Symbol("route");
function W(e = {}) {
  const r = y(), t = (...n) => ({
    id: r,
    params: n[0] ?? null,
    state: n[1] ?? null
  });
  return Object.defineProperties(t, {
    id: {
      value: r
    },
    kind: {
      value: L
    },
    name: {
      get() {
        return t.displayName ?? `route(${r})`;
      }
    },
    is: {
      value: (n) => n.id === r
    },
    key: {
      value: (n) => e.key ? `${r}:${e.key(n)}` : r
    }
  });
}
function ne(e = {}) {
  return W(e);
}
class A extends Error {
  static is(r) {
    return r instanceof Error && r.name === this.name;
  }
  constructor(r) {
    super(r), this.name = this.constructor.name, typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, this.constructor);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message
    };
  }
}
class E extends A {
  constructor(r = "") {
    super(`Route is not found: "${r}"`);
  }
}
$(E, "name", "RouteNotFoundError");
function oe(e, r) {
  if (e.id !== r.id)
    return !1;
  for (const t in e.params)
    if (e.params[t] !== r.params[t])
      return !1;
  return !0;
}
function _(e) {
  var r, t;
  return (r = e == null ? void 0 : e.searchParams) != null && r.size ? `?${(t = e == null ? void 0 : e.searchParams) == null ? void 0 : t.toString()}` : "";
}
function F(e) {
  return e === "/" ? "" : e.replace(/^\/+/, "");
}
function P(e) {
  return e === "/" ? "" : e.replace(/\/+$/, "");
}
function ie(e) {
  let r = e != null && e.basename ? P(e.basename) : "";
  const t = [], n = {};
  let o = [], i = [], a = !1, c = y(), s = 0, f;
  const h = (u) => {
    if (r) {
      if (!u.startsWith(r))
        throw new E(u);
      u = u.slice(r.length);
    }
    u = P(u) || "/";
    for (const d of t) {
      const l = n[d];
      if (!l)
        continue;
      const g = l.path.match(u);
      if (g)
        return l.route(g);
    }
    throw new E(u);
  }, S = (u, d) => {
    let l = 0;
    const g = () => {
      if (!f)
        return;
      const m = i[l++];
      if (m)
        m(f, u, g);
      else {
        const { route: I } = n[u.id];
        c = e != null && e.enableRouteKey ? I.key(u.params) : y(), f = u, s = d, o.forEach((M) => M());
      }
    };
    g();
  }, p = typeof window < "u" ? window.history : {};
  return {
    get basename() {
      return r;
    },
    get action() {
      return s;
    },
    get key() {
      return c;
    },
    get location() {
      if (!f)
        throw new E();
      return f;
    },
    get length() {
      return p.length;
    },
    ref() {
      return G;
    },
    add(u, d) {
      if (d.id in n)
        throw new Error(`Route "${d.id}" is already existed`);
      return t.push(d.id), n[d.id] = { path: u, route: d }, this;
    },
    go(u) {
      p.go(u);
    },
    back() {
      p.go(-1);
    },
    forward() {
      p.go(1);
    },
    navigate({ to: u, basename: d, replace: l, meta: g }) {
      d && (r = P(d));
      const m = this.serialize(u) + _(g);
      try {
        l ? p.replaceState(u.state, "", m) : p.pushState(u.state, "", m), S(
          u,
          l ? 2 : 1
          /* PUSH */
        );
      } catch {
        window.location.assign(m);
      }
    },
    run(u) {
      return a ? this : (a = !0, s = 0, f = h(u), typeof window < "u" && window.addEventListener("popstate", () => {
        try {
          const d = h(window.location.pathname);
          S(
            d,
            0
            /* POP */
          );
        } catch (d) {
          d instanceof E && window.location.reload();
        }
      }), this);
    },
    serialize(u) {
      const d = n[u.id];
      if (d) {
        const l = d.path.format(u.params);
        return `${r}/${F(l)}`;
      }
      return r;
    },
    listen(u) {
      return o.push(u), () => {
        o = o.filter((d) => d !== u);
      };
    },
    beforeEach(u) {
      return i.push(u), () => {
        i = i.filter((d) => d !== u);
      };
    }
  };
}
const G = k("Router"), U = /[\-{}\[\]+?.,\\\^$|#\s]/g, X = /:(\w+)(\\?)?/g, T = /:(\w+)(\?)?/g, z = /\/+/g, K = (e) => e === "true" || e === "1", j = (e) => {
  const r = Number(e);
  if (!isFinite(r) && !isNaN(r))
    return r;
}, B = String, ae = {
  boolean: K,
  number: j,
  string: B
};
function se(e, r) {
  const t = [], n = e.replace(U, "\\$&").replace(X, (i, a, c) => {
    if (!(r != null && r.hasOwnProperty(a)))
      throw new Error(`Missing parsing rule for param "${a}"`);
    return t.push({
      name: a,
      optional: !!c,
      parse: r[a]
    }), "([^/?]+)";
  }), o = new RegExp("^" + n + "(?:\\?([\\s\\S]*))?$");
  return {
    get path() {
      return e;
    },
    match(i) {
      const a = i.match(o);
      if (a) {
        let c = 1;
        return t.reduce((s, f) => {
          const h = a[c++];
          if (h != null) {
            const S = f.parse(h);
            s[f.name] = S;
          }
          return s;
        }, {});
      }
    },
    format(i) {
      return e.replace(T, (a, c, s) => {
        const f = i[c];
        if (f === void 0 && !s)
          throw new Error(`Invalid path params: "${c}"`);
        return encodeURIComponent(f);
      }).replace(z, "/");
    }
  };
}
function ue(e = {}) {
  return {
    get(r, t, n) {
      const o = e[r];
      if (t !== void 0 && o === void 0)
        return n;
      if (t === "number") {
        const i = Number(o);
        return !isNaN(i) && isFinite(i) ? i : n;
      }
      return t === "boolean" ? o === "true" || o === "1" || !!o : t === "string" ? String(o) : o;
    },
    toJSON() {
      return e;
    }
  };
}
function Q(e) {
  return typeof e == "function";
}
function b(e) {
  let r = e, t = [];
  const n = {
    refs() {
      return t.length;
    },
    get() {
      return r;
    },
    listen(o) {
      return t.push(o), () => {
        t = t.filter((i) => i !== o);
      };
    }
  };
  return {
    ...n,
    seal() {
      return n;
    },
    set(o) {
      const i = Q(o) ? o(r) : o;
      i !== r && (r = i, t.forEach((a) => a()));
    }
  };
}
function ce(e) {
  let r = e.locales;
  const t = b(e.defaultLocale);
  function n() {
    if (typeof window < "u") {
      const o = t.get();
      document.documentElement.lang = o.lang, document.documentElement.dir = o.dir;
    }
  }
  return {
    locale: t.seal(),
    get locales() {
      return r;
    },
    ref() {
      return V;
    },
    resolve(o) {
      return r.find((i) => i.lang === o);
    },
    switch(o) {
      const i = this.resolve(o);
      i && (t.set(i), n());
    },
    toJSON() {
      return {
        locale: t.get(),
        locales: r
      };
    },
    hydrate(o) {
      r = o.locales, t.set(o.locale);
    }
  };
}
const V = k("I18n");
var v = /* @__PURE__ */ ((e) => (e[e.IDLE = 0] = "IDLE", e[e.PENDING = 1] = "PENDING", e[e.ERROR = 2] = "ERROR", e[e.SUCCESS = 3] = "SUCCESS", e))(v || {});
function Z(e) {
  let r, t, n, o = 0;
  const i = b(Date.now());
  return {
    get status() {
      return o;
    },
    get data() {
      return t;
    },
    updated: i.seal(),
    read() {
      if (o === 0 && (r = e.fetch().then((a) => {
        o = 3, t = a, i.set(Date.now());
      }).catch((a) => {
        o = 2, n = a;
      }), o = 1), o === 1)
        throw r;
      if (o === 2)
        throw n;
      return t;
    },
    expired(a) {
      return e.lifetime < 0 ? !1 : i.get() + e.lifetime < a;
    },
    unused() {
      return i.refs() === 0;
    },
    toJSON() {
      var a;
      return (a = e.toJSON) == null ? void 0 : a.call(e, t);
    },
    hydrate(a) {
      var s;
      const c = (s = e.hydrate) == null ? void 0 : s.call(e, a);
      c && (t = c, o = 3);
    },
    update(a) {
      a !== t && (t = a, o = 3, i.set(Date.now()));
    }
  };
}
function fe() {
  const e = /* @__PURE__ */ new Map();
  let r;
  return {
    ref() {
      return Y;
    },
    find(t) {
      return e.get(t);
    },
    acquire(t) {
      return t.map((n) => {
        if (!e.has(n.key)) {
          const o = Z(n.params);
          if (r) {
            const i = r[n.key];
            i && o.hydrate(i);
          }
          e.set(n.key, o);
        }
        return n.key;
      });
    },
    read(t) {
      const n = [], o = t.map((i) => {
        const a = e.get(i);
        if (!a)
          throw new Error(`Resource "${i}" is not found`);
        try {
          return a.read();
        } catch (c) {
          if (c instanceof Promise)
            n.push(c);
          else
            throw c;
        }
      });
      if (n.length)
        throw Promise.all(n);
      return o;
    },
    listen(t, n) {
      const o = [];
      return t.forEach((i) => {
        const a = e.get(i);
        a && o.push(a.updated.listen(n));
      }), () => {
        o.forEach((i) => i());
      };
    },
    free() {
      const t = Date.now();
      e.forEach((n, o) => {
        (n.expired(t) || n.status === v.ERROR) && n.unused() && e.delete(o);
      });
    },
    toJSON() {
      const t = {}, n = Date.now();
      return e.forEach((o, i) => {
        if (o.expired(n))
          return;
        const a = o.toJSON();
        a && (t[i] = a);
      }), t;
    },
    hydrate(t) {
      r = t;
    }
  };
}
const Y = k("Resources");
function de(e) {
  const { toJSON: r, hydrate: t } = e;
  return (n, o) => {
    const i = e.key(n), a = {
      fetch: () => e.fetch(n),
      lifetime: (o == null ? void 0 : o.lifetime) ?? -1
    };
    return r && (a.toJSON = (c) => r(c, n)), t && (a.hydrate = (c) => t(c, n)), {
      key: i,
      params: a
    };
  };
}
function le(e) {
  const { toJSON: r, hydrate: t } = e;
  return (n, { pagination: o, lifetime: i = -1 }) => {
    const a = e.key(n), c = {
      fetch: (s) => {
        const f = e.nextPageInfo(s);
        return e.fetch(n, s, f);
      },
      lifetime: i
    };
    return r && (c.toJSON = (s) => r(s, n)), t && (c.hydrate = (s) => t(s, n)), o.attach(a, {
      fetch: (s, f) => e.fetch(n, s, f),
      nextPageInfo: e.nextPageInfo
    }), {
      key: a,
      params: c
    };
  };
}
function he(e) {
  const r = b("idle");
  let t, n, o = !1;
  return {
    status: r.seal(),
    attach(i, a) {
      if (t && i !== t)
        throw new Error("Infinite pagination is already attached to another rosource");
      t = i, n = a;
    },
    fetch() {
      if (!t || !n)
        throw new Error("Infinite pagination is not attached to any resource");
      if (r.get() === "loading")
        return;
      const i = e.find(t);
      if (!i || i.status !== v.SUCCESS)
        return;
      const a = i.data, c = n.nextPageInfo(a);
      c !== void 0 && (r.set("loading"), n.fetch(a, c).then((s) => {
        o || (r.set("idle"), i.update(s));
      }).catch(() => {
        o || r.set("error");
      }));
    },
    effect() {
      return o = !1, () => {
        o = !0;
      };
    }
  };
}
export {
  A as CustomError,
  ae as PathParam,
  E as RouteNotFoundError,
  se as compilePath,
  ee as createApplicationManager,
  ue as createFlags,
  ce as createI18nManager,
  he as createInfinitePagination,
  le as createInfiniteQuery,
  W as createMetaRoute,
  k as createRef,
  de as createResourceQuery,
  fe as createResources,
  ne as createRoute,
  ie as createRouter,
  re as createScenario,
  b as createSignal,
  te as createWidget,
  oe as equalsLocation,
  V as i18nRef,
  Y as resourcesRef,
  G as routerRef
};
